import React, { useState, useEffect } from 'react';
import { useNotifications } from '../../../../../../shared/hooks/Notifications';
import { ServerErrorMessage } from '../../../../../../shared/utils/error';
import { InformeProvisionalDefinitivoMesAnteriorScreen } from './screen';
import { InformesAdapter } from '../../../../../../infraestructure/persistence/rest/InformesAdapter';


export const InformeProvisionalDefinitivoMesAnteriorContainer = (props:any) => {

	const api = new InformesAdapter();
	const {resultError, exceptionError, launchNotification} = useNotifications();
	
	let [ data, setData ] = useState<any>([]);
	let [isLoading, setIsLoading] = useState(false)
	let result: any;


	const getData = async (anio:number) => {
		setIsLoading(true);
		try {
			result = await api.ProvisionalDefinitivoMesAnteriorExpatriados(anio);
			if(result.data && result.data!=="")
			{
				setData([ ...result.data ] || []);
			}else{resultError()}
			setIsLoading(false);
		} catch (error) {
			let exception = ServerErrorMessage(error);
			exceptionError(exception)
			setIsLoading(false);
		}
	};

	return(
		<InformeProvisionalDefinitivoMesAnteriorScreen data={data} getData={getData} isLoading={isLoading} {...props}/>
	);
};